import React, { useEffect } from 'react';

//  import Testimonials from './Testimonials';

import CarrersBanner from './CarrersBanner';
import Carrersbuttonscrollpage from './Carrersbuttonscrollpage';
import Carearrscodetoscroll from './Carearrscodetoscroll';
import RequestForm from './RequestForm';
const CarrersPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts all the formated data not activated in the real time units and fuctinoalite of the cde 
 
  return (
    <div style={{background:'#fff'}}>
        <CarrersBanner />
        {/* <Carearrscodetoscroll /> */}
         {/* <RequestForm  /> */}
        
      



        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style>
    </div>
  )
}

export default CarrersPage;